module.exports = __webpack_public_path__ + "static/landingLogo-1939170520f8b1ab07c7c864b17ed099.png";